/**
 * @file actions/Content/constants.js
 * @copyright 2016 CBC/Radio-Canada. All rights reserved.
 */

const SUCCESS = "SUCCESS";
const FAILURE = "FAILURE";
const CONTENT_TYPE_NOT_AVAILABLE = "CONTENT_TYPE_NOT_AVAILABLE";

export const STATUS_CODES = {
    SUCCESS,
    FAILURE,
    CONTENT_TYPE_NOT_AVAILABLE,
};

// Certain sections don't want to display any data beyond the PubQ, e.g. News
// For those sections, provide an overriding category id, e.g. "topstories"
export const OVERRIDE_CATEGORY = {
    alone: "radio/alone",
    archives: "archives",
    archivesArts: "archives/arts",
    archivesHistory: "archives/history",
    archivesSports: "archives/sports",
    cape: "cape",
    capePostings: "cape/postings",
    cbcGives: "life/holiday/cbcgives",
    costOfLiving: "radio/costofliving",
    crashedIce: "sports/crashed-ice",
    documentariesCategory: "documentaries",
    greatCanadianBakingBakerCategory: "life/greatcanadianbakingshow",
    fifaWorldCup: "sports/soccer/worldcup",
    findingCleo: "radio/findingcleo",
    fridgeLight: "radio/thefridgelight",
    frontburner: "radio/frontburner",
    indspire: "indspire",
    inTheMaking: "arts/inthemaking",
    iqPodcast: "radio/iqpodcast",
    iqPodcastTranscripts: "radio/iqpodcast/transcripts",
    learningEnglish: "learning-english",
    musicReadVideo: "music/read/video",
    musicExplore: "music/explore",
    musicEvents: "music/events",
    musicCCMAs: "music/ccmas",
    musicTheIntro: "music/the-intro",
    missingandmurdered: "radio/asithappens/missingandmurdered",
    musicJunosVideo: "music/junos/watch/video",
    loveMe: "radio/loveme",
    micdrop: "radio/micdrop",
    micdropTranscripts: "radio/micdrop/transcripts",
    override: "topstories",
    onDrugs: "radio/ondrugs",
    otherPeoplesproblems: "radio/opp",
    personalBest: "radio/personalbest",
    podcastnews: "radio/podcastnews",
    podcasts: "sports/podcasts",
    podcastsHnic: "sports/podcasts/hnic",
    playersOwnVoice: "sports/podcasts/players-own-voice",
    qVideo: "radio/q/video",
    recall: "radio/recall",
    secretlifeofcanada: "radio/secretlifeofcanada/transcripts",
    sleepover: "radio/sleepover",
    someoneKnowsSomething: "radio/sks",
    soccerMLS: "sports/soccer/mls",
    soccerCPL: "sports/soccer/cpl",
    taiaskswhy: "radio/taiaskswhy",
    thisisthat: "radio/thisisthat",
    uncover: "radio/uncover",
    uncoverSeason1: "radio/uncover/season1",
    uncoverSeason2: "radio/uncover/season2",
    uncoverSeason3: "radio/uncover/season3",
    uncoverSeason4: "radio/uncover/season4",
    uncoverSeason5: "radio/uncover/season5",
    uncoverSeason6: "radio/uncover/season6",
    whatonearth: "radio/whatonearth",
    jamieOliver: "life/jamieoliver",
    jamieOliverRecipes: "life/jamieoliver/recipes",
    jamieOliverWatch: "life/jamieoliver/watch",
    battleofblades: "television/battleoftheblades",
    skaters: "television/battleoftheblades/skaters",
    blades: "television/battleoftheblades/blades-performances",
    mini: "television/battleoftheblades/mini-blades",
    fridgeWars: "life/fridgewars",
    familyFeud: "television/familyfeud",
    highArcticHaulers: "television/higharctichaulers",
    backInTimeForWinter: "life/backintimeforwinter",
    briefButSpectacular: "documentaries/brief-but-spectacular",
};
